import { RootReducer } from '../rootReducer';

export const selectCurrentUser = (state: RootReducer) => state.user;

export const selectIsUserFromCalifornia = (state: RootReducer) => {
    const user = selectCurrentUser(state);

    return Boolean(user && user?.is_california);
};
